export const ADMIN_HOME = '/admin/reports';
export const getDefaultHomePath = () => ADMIN_HOME;
